module.exports = __webpack_public_path__ + "img/logo-apollo.0b02eba.png";